<template>
    <div v-show="visible" class="dialog-tips">
        {{message}}
    </div>
</template>

<script>
    export default {
        name: "toast",
        data() {
            return {
                visible: false,
                message: ""
            };
        }
    }
</script>

<style scoped>
    .dialog-tips{
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        /*box-shadow: 0px 8px 15px 0 rgba(0, 0, 0, 0.1);*/
        text-align: center;
        padding: 0 0.2rem;
        line-height: 0.6rem;
        font-size: 0.3rem;
        background-color: #f0861b;
        color: white;
        border-radius: 2px;
        z-index: 20000;
        max-width: 90%;
        width: auto;
    }

</style>



// WEBPACK FOOTER //
// src/shared/components/toast.vue